import * as _dateFns from "date-fns";
import * as dateFormat from "./format.js";
export const date = {
    ..._dateFns,
    ...dateFormat,
};
export * from "./dobToAgeRange/index.js";
